<template>
  <!-- name: '手机验证码登录界面' -->
  <div class="registerDefaultWrap">
    <img
      src="https://img.bbalt.cn/imgh5/userCenter/img_line1.svg"
      alt=""
      class="lineClass line1"
    />
    <img
      src="https://img.bbalt.cn/imgh5/userCenter/img_line2.svg"
      alt=""
      class="lineClass line2"
    />
    <img
      src="https://img.bbalt.cn/imgh5/logo_register_apply.png"
      alt=""
      class="logoClass"
    />
    <div class="formClass">
      <div class="input-row">
        <input
          type="tel"
          placeholder="请输入手机号"
          v-model="mobile"
          maxlength="11"
          @input="validateMobile"
        />
        <div class="error-message">
          <span v-show="mobileError">{{ mobileError }}</span>
        </div>
      </div>

      <div class="input-row codeBox">
        <input
          type="text"
          placeholder="请输入6位验证码"
          v-model="code"
          maxlength="6"
        />
        <button
          id="sendCode"
          class="send-btn"
          :disabled="isCountingDown || !isMobileValid"
          @click="sendVerificationCode"
        >
          {{ buttonText }}
        </button>
        <div class="error-message" v-show="codeError">{{ codeError }}</div>
      </div>

      <div class="checkBox">
        <input
          type="checkBox"
          required
          :checked="isChecked"
          @click="isChecked = !isChecked"
        />我已阅读并同意<span @click="showDialog = true">《需知协议》</span>
      </div>
      <button class="login-btn" :disabled="!isFormValid" @click="handleLogin">
        {{ loginBtnText }}
      </button>
    </div>
  </div>
</template>

<script>
import { setToken } from "@/utils/localToken.js";
import { sendSmsCode, phoneCodeLoginApi } from "@/api/userCenter";
export default {
  components: {},
  data() {
    return {
      isChecked: false,
      showCheck: false,
      showDialog: false,
      showTips: false,
      mobile: "", // 手机号
      code: "", // 验证码
      mobileError: "", // 手机号错误信息
      codeError: "", // 验证码错误信息
      isMobileValid: false, // 手机号验证状态
      isCountingDown: false, // 倒计时状态
      countDown: 60, // 倒计时秒数
      buttonText: "获取验证码", // 按钮文字
      loginBtnText: "登 录", // 登录按钮文字
      isLoading: false, // 登录加载状态
    };
  },
  computed: {
    isFormValid() {
      return this.isMobileValid && this.code.length === 6 && this.isChecked;
    },
  },
  methods: {
    // 手机号验证
    validateMobile() {
      const mobilePattern = /^1[3-9]\d{9}$/;

      if (!this.mobile) {
        this.mobileError = "手机号不能为空";
        this.isPhoneValid = false;
      } else if (!mobilePattern.test(this.mobile)) {
        this.mobileError = "请输入有效的手机号";
        this.isPhoneValid = false;
      } else {
        this.mobileError = "";
        this.isMobileValid = true;
      }
    },
    // 验证码验证
    validateCode() {
      const codePattern = /^\d{6}$/;

      if (!this.code) {
        this.codeError = "验证码不能为空";
      } else if (!codePattern.test(this.code)) {
        this.codeError = "请输入6位数字验证码";
      } else {
        this.codeError = "";
      }
    },
    // 发送验证码
    sendVerificationCode() {
      if (!this.isMobileValid) {
        this.mobileError = "请输入有效的手机号";
        return;
      }
      this.isCountingDown = true;
      this.buttonText = `${this.countDown}秒后重发`;
      sendSmsCode({ mobile: this.mobile }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(`验证码已发送到 ${this.mobile}`);
          const timer = setInterval(() => {
            this.countDown--;

            if (this.countDown <= 0) {
              clearInterval(timer);
              this.isCountingDown = false;
              this.buttonText = "获取验证码";
              this.countDown = 60;
            } else {
              this.buttonText = `${this.countDown}秒后重发`;
            }
          }, 1000);
        } else {
          this.$toast.fail(`${res.message ? res.message : "验证码发送失败！"}`);
        }
      });
    },
    // 登录处理
    handleLogin() {
      if (!this.isFormValid) return;
      // 更新按钮状态
      this.isLoading = true;
      this.loginBtnText = "登录中...";
      const params = {'mobile': this.mobile, 'smsCode': this.code}
      phoneCodeLoginApi(params).then((res) => {
        if (res.code === 200) {
          this.$toast.success("登录成功!");
          this.loginBtnText = "登录";
          setToken(res.content);
          this.$router.push({ path: "/home" });
        } else {
          this.$toast.success('登录失败：' + res.message);
        }
        this.isLoading = false;
      })
    },
    handleConfirm() {
      this.isChecked = !this.isChecked;
    },
  },
};
</script>

<style lang="scss" scoped>
.registerDefaultWrap {
  height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #fbf0f6, rgba(255, 255, 255, 0) 30%),
    linear-gradient(215deg, #e9f1f8, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #fff, #fff 45%);
  overflow: auto;
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  font-family: PingFang-SC, PingFang-SC;
  .lineClass {
    position: absolute;
    &.line1 {
      top: -26px;
      right: 0px;
      width: 238px;
      height: 162px;
    }
    &.line2 {
      bottom: 347px;
      left: 2px;
      width: 117px;
      height: 57px;
    }
  }
  .logoClass {
    width: 240px;
    height: 130px;
    margin-top: 161px;
  }
  .formClass {
    margin-bottom: 26px;
    display: flex;
    flex-flow: column;
    align-items: center;

    .input-row {
      display: flex;
      flex-flow: column;
    }
    input {
      margin-top: 40px;
      width: 678px;
      height: 96px;
      background: #f5f5f5;
      border-radius: 47px;
      border: none;
      padding-left: 48px;
      &::placeholder {
        font-size: 30px;
        font-weight: 400;
        color: #999999;
      }
    }
    .codeBox {
      position: relative;
      .send-btn {
        position: absolute;
        top: 10px;
        right: 0px;
        width: 30%;
      }
    }
    .error-message {
      color: #ff4d4f;
      font-size: 24px;
      margin-top: 5px;
      margin-left: 20px;
      height: 20px;
      line-height: 20px;
      padding: 8px 14px;
      display: inline-block;
    }
    .checkBox {
      margin-top: 32px;
      display: flex;
      justify-content: flex-start;
      width: 100%;
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 32px;
      height: 32px;
      input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("https://img.bbalt.cn/imgh5/icon_unselect.png");
        background-size: 30px 30px;
        background-repeat: no-repeat;
        width: 30px !important;
        height: 30px !important;
        outline: none;
        box-sizing: border-box;
        padding: 0px;
        border-radius: 0px;
        border: none;
        background-color: #d8d8d8;
        margin-top: 0px;
        margin-right: 16px;
        margin-left: 8px;
      }
      input[type="checkbox"]:checked:checked {
        background: url("https://img.bbalt.cn/imgh5/icon_select.svg") no-repeat
          center;
        background-size: 100% 100%;
      }
    }
    button {
      width: 678px;
      height: 96px;
      background: #fe74ae;
      border-radius: 47px;
      border: none;
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
      margin-top: 32px;
    }

    .send-btn:disabled {
      background: #eeeeee;
      cursor: not-allowed;
      color: #999999;
    }
    .login-btn:disabled {
      background: #eeeeee;
      cursor: not-allowed;
      color: #999999;
    }
  }
}
.van-dialog p {
  padding: 20px;
  line-height: 40px;
  text-align: center;
}
::v-deep .van-dialog__header {
  color: #000;
}
::v-deep .van-dialog__content {
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin: 30px 0px;
}
</style>
